import {Pagination, PaginationItemType} from "@heroui/react";
import {ReactComponent as ChevronIcon} from "../assets/icons/arrow-left.svg";

export default function PaginationApp({pages, currentPage, ...props}) {
    const renderItem = ({
                            ref,
                            key,
                            value,
                            isActive,
                            onNext,
                            onPrevious,
                            setPage,
                            className = '',
                        }) => {
        if (value === PaginationItemType.NEXT) {
            return (
                <button key={key} className={`sm:!w-8 !w-6 sm:!h-8 !h-6 ${className}`} onClick={onNext}>
                    <ChevronIcon/>
                </button>
            );
        }

        if (value === PaginationItemType.PREV) {
            return (
                <button key={key} className={`sm:!w-8 !w-6 sm:!h-8 !h-6 ${className}`} onClick={onPrevious}>
                    <ChevronIcon className="rotate-180"/>
                </button>
            );
        }

        if (value === PaginationItemType.DOTS) {
            return <button key={key} className={`sm:!w-8 !w-6 sm:!h-8 !h-6`}>...</button>;
        }

        // cursor is the default item
        return (
            <button
                key={key}
                ref={ref}
                className={`sm:!w-8 !w-6 sm:!h-8 !h-6 !min-w-0 centerOfParent !bg-Primary-50 !rounded ${className} ${isActive && 'bg-gradient-to-t from-Primary-800 to-Primary-200'}`}
                onClick={() => setPage(value)}
            >
                {value}
            </button>
        );
    };

    return (
        <>
            {pages > 1 && <Pagination
                disableCursorAnimation
                showControls
                total={pages}
                page={currentPage || 1}
                className="sm:[&>ul]:gap-3"
                radius="full"
                renderItem={renderItem}
                variant="light"
                {...props}
            />}
        </>
    );
}